import { PlatformConstants } from "@quest/platform-murka/dist/PlatformConstants"


export class PlatformConstantsGame extends PlatformConstants {
    // code here
}
PlatformConstants.BASE_GAME_REELSET = 'base_reel_100';
PlatformConstants.FREE_GAME_REELSET = 'free_reel_300';


